import gql from "graphql-tag";

export default gql`
  query listComments($orderId: ID!, $limit: Int, $nextToken: String) {
    listComments(orderId: $orderId, limit: $limit, nextToken: $nextToken) {
      items {
        id
        orderId
        author
        responseTo
        createdAt
        updatedAt
        message
        files {
          bucket
          region
          key
          identityId
          __typename
        }
        visibility
        isDeleted
        admin
        __typename
      }
      nextToken
    }
  }
`;



// WEBPACK FOOTER //
// ./src/GraphQL/Query/ListComments.js